

















































import { Component, Prop, Vue } from 'vue-property-decorator';

import Assets from '@/constants/assets';
import Btn, {
  BtnWidth,
  BtnHeight,
  BtnColor
} from '@/shared/components/btn.component.vue';
import Input, {
  InputType,
  InputStyle
} from '@/shared/components/input.component.vue';
import SpotlightText, {
  SpotlightTextColor,
  SpotlightTextBorderType
} from '@/shared/components/SpotlightText.component.vue';
import AppService, { Applications } from '@/core/services/app.service';
import UtilsService from '@/core/services/utils.service';

@Component({
  components: {
    Btn,
    Input,
    SpotlightText
  }
})
export default class Login extends Vue {
  private assets = Assets;
  private applications = Applications;
  private email: string = '';
  private password: string = '';
  private inputType = InputType;
  private inputStyle = InputStyle;
  private btnColor = BtnColor;
  private btnWidth = BtnWidth;
  private btnHeight = BtnHeight;
  private rememberAccess = false;
  private spotlightTextColor = SpotlightTextColor;
  private spotlightTextBorderType = SpotlightTextBorderType;
  private showingError = false;
  private app: string = AppService.current();
  private showAppSelector: boolean = UtilsService.inDebug();

  get brandAppLogo() {
    let brand = this.assets.managerLogo;
    if (this.app === this.applications.clickbuy) {
      brand = this.assets.clickbuyLogo;
    }
    return brand;
  }

  private login() {
    this.showingError = false;
    this.$store
      .dispatch('authRequest', { email: this.email, password: this.password })
      .then(() => {
        this.fetchProfile();
        this.$router.push('/');
      })
      .catch((err) => {
        this.showingError = true;
      });
  }

  private fetchProfile() {
    this.$store.dispatch('fetchProfile');
  }

  private handleKey(e: any) {
    if (e.keyCode === 13) {
      this.login();
    }
  }

  private handleClick() {
    this.showingError = false;
  }

  private changeApp(app: string): void {
    AppService.changeApp(app);
  }
}
